export const AlternatingRows = ({ data, heading }) => {
  return (
    <div className="alternating-rows-wrapper">
      {heading && (
        <div className="heading-row">
          <span>{heading}</span>
        </div>
      )}

      <div className="alternating-rows">
        {data.map((item, index) => (
          <div
            key={index}
            className={`row-item ${index % 2 === 0 ? "row-light" : "row-dark"}`}
          >
            <span className="label">{item.label}</span>
            <span className="value">{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
